/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Public_PhoneInputs */

const cs_settings_profile_public_phone = /** @type {(inputs: Settings_Profile_Public_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veřejný telefon`)
};

const en_settings_profile_public_phone = /** @type {(inputs: Settings_Profile_Public_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public phone`)
};

/**
* | output |
* | --- |
* | "Public phone" |
*
* @param {Settings_Profile_Public_PhoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_public_phone = /** @type {((inputs?: Settings_Profile_Public_PhoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Public_PhoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_public_phone(inputs)
	return cs_settings_profile_public_phone(inputs)
});